import { Link } from 'react-router-dom';
import Seal from '../common/Seal';

const SEASON = {
  year_round: { label: 'Year round', className: 'pill pill-open' },
  seasonal: { label: 'Seasonal', className: 'pill pill-seasonal' },
  unknown: null,
};

export default function BusinessCard({ business }) {
  const image = business.primary_image || business.primaryImage;
  const season = SEASON[business.season];

  return (
    <article className={business.featured_tier > 0 ? 'card card-featured' : 'card'}>
      <Link to={`/listing/${business.slug}`} className="card-link">
        <div className="card-media">
          {image?.url ? (
            <img src={image.url} alt={image.alt || business.name} loading="lazy" />
          ) : (
            <div className="card-media-empty" aria-hidden="true" />
          )}
          {business.featured_tier > 0 && <span className="badge">Featured</span>}
        </div>

        <div className="card-body">
          <div className="card-text">
            <h3>{business.name}</h3>
            {business.tagline && <p className="card-tagline">{business.tagline}</p>}

            <p className="card-meta">
              {business.category?.name}
              {business.town?.name ? ` · ${business.town.name}` : ''}
            </p>

            {season && <span className={season.className}>{season.label}</span>}
          </div>

          <div className="card-seal">
            <Seal value={business.last_verified_at} />
          </div>
        </div>
      </Link>
    </article>
  );
}
